import { render, staticRenderFns } from "./vOrderPurcharse.vue?vue&type=template&id=7dcd866f&"
import script from "./vOrderPurcharse.vue?vue&type=script&lang=js&"
export * from "./vOrderPurcharse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports